"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RoutableComponent_1 = require("./RoutableComponent");
exports.default = RoutableComponent_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/routables/RoutableComponent/index.js
// module id = 997
// module chunks = 8